import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';

const SKUDetailStorageOrderItem=({parentId,application,userData,parent})=>{
    const list_name='sku_storage_order_items';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'StorageOrderItem'}
                entityParams={['sku_id='+parentId,'_context='+['parent_name=SKU'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'SKUDetailStorageOrderItem.js'}
                navigateOnNew={null}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                getRowClassName={(params)=>
                    (application.globalData.list_of_values_reverse.Delivery_Status?.[params.row.order_delivery_status]==='COMPLETED'&&params.row.quantity!==params.row.quantity_delivered)?'highlight-row':''
                }
                dataGridSx={{
                    "& .highlight-row":{
                        backgroundColor:"#ffe6f0 !important",
                        color:"black",
                    },
                    "& .highlight-row .MuiDataGrid-cell[data-field='quantity_delivered']":{
                        color:"darkred",
                    }
                }}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return(renderListTab);
}
export default SKUDetailStorageOrderItem;